import React from 'react';

const Body = (props) => {
  const { children } = props;
  return <div className="w-screen h-screen bg-gray-700">{children}</div>;
};

export default Body;
